function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.337h512v113.775H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 312.888h512v113.775H0zm300.345-92.505h-17.863c.148 1.963.232 3.944.232 5.936 0 13.207-3.301 26.01-9.057 35.122-1.775 2.812-4.759 6.78-8.753 9.456v-50.514h-17.809v50.514c-3.994-2.677-6.977-6.646-8.753-9.456-5.756-9.113-9.056-21.915-9.056-35.122 0-1.992.085-3.974.232-5.936h-17.863a100.953 100.953 0 00-.177 5.936c.001 36.617 19.557 65.299 44.523 65.299s44.522-28.682 44.522-65.299a102.71 102.71 0 00-.178-5.936z",
  fill: "#d80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.522 184.275h22.261v24.421H44.522zm-44.522 0h22.261v24.421H0zm89.043 0h22.261v24.421H89.043zm44.522 0h22.261v24.421h-22.261zm44.522 0h22.261v24.421h-22.261zm44.522 0h22.261v24.421h-22.261zm44.521 0h22.261v24.421H267.13zm44.522 0h22.261v24.421h-22.261zm44.522 0h22.261v24.421h-22.261zm44.522 0h22.261v24.421h-22.261zm44.521 0h22.261v24.421h-22.261zm44.522 0H512v24.421h-22.261zM44.522 302.191h22.261v25.534H44.522zm-44.522 0h22.261v25.534H0zm89.043 0h22.261v25.534H89.043zm44.522 0h22.261v25.534h-22.261zm44.522 0h22.261v25.534h-22.261zm44.522 0h22.261v25.534h-22.261zm44.521 0h22.261v25.534H267.13zm44.522 0h22.261v25.534h-22.261zm44.522 0h22.261v25.534h-22.261zm44.522 0h22.261v25.534h-22.261zm44.521 0h22.261v25.534h-22.261zm44.522 0H512v25.534h-22.261z",
  fill: "#f0f0f0"
});

const SvgIran = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIran, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iran.06a43972.svg";
export { ForwardRef as ReactComponent };